import styled from "styled-components"
import Accordion from '@mui/material/Accordion';
import AccordionDetails from '@mui/material/AccordionDetails';
import AccordionSummary from '@mui/material/AccordionSummary';

interface AccordionCustom {
    color?: string
    background?: string
    textColor?: string
}

export const AccordionCustom = styled(Accordion)<AccordionCustom>`
    background-color: ${p => p.background};
    color: ${p => p.textColor};
    padding: 0;
    margin-bottom: 3px;
    border: none;    
    box-shadow: 0px 3px 6px #00000029;
    border-left: 15px solid ${p => p.color};
    font-family: MontserratRegular;
  
    &:before {
        display: none;
    }

    &.MuiPaper-root-MuiAccordion-root {
        background-color: transparent;
        cursor: pointer;
    }
`

interface AccordionSummaryCustom {
    background?: string
}

export const AccordionSummaryCustom = styled(AccordionSummary)<AccordionSummaryCustom>`
    background-color: ${p => p.background};
    cursor: pointer;
  
    &.MuiButtonBase-root.MuiAccordionSummary-root {
        cursor: pointer;
    }

    &.MuiAccordionSummary-expandIconWrapper.Mui-expanded {
        transform: rotate(90deg);
    }
`

export const SummaryContainer = styled.div`
    width: 100%;
    height: 15px;
    background-color: transparent;
    border-radius: 5px;
    border: 0;
    display: flex;
    flex-direction: row;
    justify-content: start;
    opacity: 1;
    cursor: pointer;
    font-size: 1rem;
    padding-right: 2rem;
    cursor: pointer;
`

export const ReportRowName = styled.label`
    width: 80%; 
    text-align: left;
    font-size: 1rem;
    font-weight: 500;
    display: flex;
    align-items: center;
    cursor: pointer;
`

export const ReportRowCounter = styled.div`
    width: 20%; 
    padding-right: 1rem;
    display: flex;
    align-items: center;
    justify-content: end;
    cursor: pointer;
`

interface Counter {
    background?: string
    textColor?: string
}

export const Counter = styled.div<Counter>`
    background-color: ${p => p.background};
    color: ${p => p.textColor};
    width: 3rem;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 1.1rem;
    font-weight: 500;
    border: none;    
    box-shadow: 0px 3px 6px #00000029;
    border-radius: 12px;
`

interface AccordionDetailsCustom {
    background?: string
}

export const AccordionDetailsCustom = styled(AccordionDetails)<AccordionDetailsCustom>`
    background-color: ${p=> p.background};
    max-height: fit-content;    
    padding: 2px;
    border-top: 1px solid rgba(0, 0, 0, .125);
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    grid-gap: 5px;

    @media (max-width: 780px) {
        display: flex;
        flex-direction: column;
    }
`

interface ReportRow {
    background?: string
    textColor?: string
}

export const ReportRow = styled.div<ReportRow>`
    background-color: ${p => p.background};
    color: ${p => p.textColor};
    width: 100%;
    border: none;    
    box-shadow: 0px 3px 6px #00000029;
    border-radius: 5px;
    height: 50px;
    display: flex;
    align-items: center;
    font-size: 1rem;
    font-weight: 400;
    padding: 0.5rem 1.5rem 0.5rem 1.5rem;
    margin-bottom: 3px;

    @media (max-width: 780px) {
        padding: 0.5rem 1rem 0.5rem 1rem;
    }
`

export const ReportSmallRowName = styled.label`
    width: 70%; 
    overflow: hidden;
    white-space: pre-line;
    text-align: left;
    font-size: 1rem;
    font-weight: 500;
    cursor: pointer;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;

    &:hover {
        overflow: visible;
    }
`

export const ReportRowIcons = styled.div`
  width: 30%;
  display: flex;
  flex-direction: row;
  align-items: start;
  justify-content: end;
  font-size: clamp(1.2rem, 2.5vw, 1.2rem);
  margin-bottom: 0;
  padding: 5px;
`

export const Image = styled.img`
  width: 22px;
  height: 22px;
  border: none;
  margin: 2px 0 0 5px;
  cursor: pointer;
`